import { render, staticRenderFns } from "./ReferralHistoryModal.vue?vue&type=template&id=f318b586&scoped=true&"
import script from "./ReferralHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralHistoryModal.vue?vue&type=style&index=0&id=f318b586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f318b586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f318b586', component.options)
    } else {
      api.reload('f318b586', component.options)
    }
    module.hot.accept("./ReferralHistoryModal.vue?vue&type=template&id=f318b586&scoped=true&", function () {
      api.rerender('f318b586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/referral/components/ReferralHistoryModal.vue"
export default component.exports